import React from 'react';
import ProductCard from './ProductCard';

const BookGrid = ({ books, onLike, likedBooks }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3">
      {books.map((book, index) => {
        // Create unique key based on product type and ID
        const uniqueKey = book.product_type === 'bible' 
          ? `bible-${book.bible_id || book.id_bible}` 
          : book.product_type === 'thing' 
            ? `thing-${book.thing_id || book.id_thing}`
            : `book-${book.id_product}`;
            
        return (
          <ProductCard
            key={uniqueKey}
            product={book}
            onLike={onLike}
            likedBooks={likedBooks}
            index={index}
            priority={index < 8}
          />
        );
      })}
    </div>
  );
};

export default BookGrid;
